import React, { useCallback, useRef } from 'react';
import { withStyles } from 'material-ui/styles';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';
import Cropper from 'react-cropper';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Popup from '../Popup';
import { styles } from './styles';

const CropModalImpl = ({
  intl: { formatMessage },
  onImageCrop,
  onClose,
  aspectRatio,
  title,
  tip,
  image,
  rounded,
  classes,
}) => {
  const cropperRef = useRef();

  const handleSubmit = useCallback(() => {
    const data = cropperRef.current.cropper.getCroppedCanvas().toDataURL();
    onImageCrop(data);
    onClose();
  }, []);

  return (
    <div>
      <Popup
        strictClose
        footerEnd
        customControls
        enabled
        submitText={formatMessage({ id: 'common.save' })}
        title={title}
        onClose={onClose}
        onSubmit={handleSubmit}
        opened={!!image}
      >
        <Cropper
          ref={cropperRef}
          minCropBoxWidth={50}
          minCropBoxHeight={50}
          aspectRatio={aspectRatio}
          className={cn(classes.cropper, { [classes.rounded]: rounded })}
          src={image}
        />
        {tip && <p className={classes.tip}>{tip}</p>}
      </Popup>
    </div>
  );
};

export const CropModal = compose(
  injectIntl,
  withStyles(styles),
)(CropModalImpl);

const propsTypes = {
  onClose: PropTypes.func.isRequired,
  onImageCrop: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  tip: PropTypes.string,
  rounded: PropTypes.bool,
  aspectRatio: PropTypes.number,
};

const defaultProps = {
  onImageCrop: () => {},
  aspectRatio: 1,
  rounded: false,
  tip: '',
  image: '',
};

CropModalImpl.propTypes = {
  classes: PropTypes.object.isRequired,
  ...propsTypes,
};
CropModalImpl.defaultProps = { ...defaultProps };

CropModal.propTypes = propsTypes;
CropModal.defaultProps = defaultProps;



// WEBPACK FOOTER //
// ./src/components/common/CropModal/index.jsx